import "svelte/store";
let serialCache = {};
export async function getDeviceInfo(device) {
    if (serialCache[device.Serial]) {
        return serialCache[device.Serial];
    }
    let response = await fetch("/.netlify/functions/index?mode=google&serial=" +
        encodeURIComponent(device.Serial));
    console.log("Fetching device Info for ", device.Serial);
    if (response.status == 200) {
        let json = await response.json();
        console.log("getDeviceInfo returning", json);
        serialCache[device.Serial] = json.result;
        return json.result;
    }
}
let userCache = {};
export async function getDevicesForUser(user) {
    if (userCache[user.Email]) {
        return userCache[user.Email];
    }
    let response = await fetch("/.netlify/functions/index?mode=google&user=" +
        encodeURIComponent(user.Email));
    console.log("Fetching devices for ", user.Email);
    if (response.status == 200) {
        let json = await response.json();
        console.log("getDevicesForUser returning", json);
        userCache[user.Email] = json.result;
        return json.result;
    }
}
export async function checkMachineStatus(asset) {
    var _a, _b, _c, _d, _e, _f, _g;
    const googleData = await getDeviceInfo(asset);
    if (!googleData) {
        console.warn("No Google Admin data found for asset:", asset["Asset Tag"]);
        return {
            status: "No data",
            lastUserMatch: false,
            lastUsed: null,
            googleData,
        };
    }
    const lastUser = ((_c = (_b = (_a = googleData.recentUsers) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.email) === null || _c === void 0 ? void 0 : _c.toLowerCase()) || null;
    const signedOutTo = ((_e = (_d = asset["Email (from Student (Current))"]) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.toLowerCase()) || null;
    const lastUserMatch = lastUser && signedOutTo && lastUser === signedOutTo;
    const lastUsedDate = ((_g = (_f = googleData.activeTimeRanges) === null || _f === void 0 ? void 0 : _f[googleData.activeTimeRanges.length - 1]) === null || _g === void 0 ? void 0 : _g.date) || null;
    return {
        status: lastUserMatch ? "Match" : "Mismatch",
        lastUserMatch,
        lastUsed: lastUsedDate,
        googleData,
    };
}
